import { createSlice } from '@reduxjs/toolkit';
import { configureTransport } from '../../api/transport';

export const counterSlice = createSlice({
    name: 'work',
    initialState: {
        isReadyToWork: false,
        statsUpdateTrigger: 0,
        isPaused: false,
    },
    reducers: {
        setIsReadyToWork: (state, action) => {
            state.isReadyToWork = action.payload || false;
        },
        triggerStatsUpdate: (state) => {
            state.statsUpdateTrigger += 1;
        },
        setIsPaused: (state, action) => {
            state.isPaused = action.payload || false;
        },
    },
});

export const {setIsReadyToWork, triggerStatsUpdate, setIsPaused } = counterSlice.actions;

export default counterSlice.reducer;
